import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { groupBy, map, uniqBy } from 'lodash-es';
import { TidService } from 'src/app/auth/services/tid.service';
import { CompanyType } from 'src/app/utils/companyType';
import { JobTitle } from 'src/app/utils/jobTitle';
import { displayValue } from 'src/app/utils/month';
import { States, STATES } from 'src/app/utils/states';
import { FormField } from 'src/app/_models/form-field';

@Component({
  selector: 'app-account-information',
  templateUrl: './account-information.component.html',
  styleUrls: ['./account-information.component.scss'],
})
export class AccountInformationComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Output() completeForm = new EventEmitter<any>();

  stateOptions: { country: string; state: States[] }[];
  countryOptions: displayValue[];
  accountField: FormField[];
  isFormValid: boolean;
  constructor(private tidService: TidService) {}

  ngOnInit(): void {
    this.stateOptions = map(groupBy(STATES, 'country'), (value, key) => {
      return { country: key, state: value };
    });

    this.countryOptions = uniqBy(STATES, 'country').map(({ country }) => ({
      display: country,
      value: country,
    }));

    this.accountField = [
      {
        fieldName: 'emailAddress',
        labelName: 'Email Address(Username)',
        fieldType: 'text',
        disabled: true,
        value: this.tidService.email,
        validations: {
          staticValidations: { required: true, emailPattern: true },
        },

        colWidth: 'col-md-3 col-sm-3',
      },

      {
        fieldName: 'companyName',
        labelName: 'Company Name',
        fieldType: 'text',
        value: '',
        validations: {
          staticValidations: { required: true },
          asyncValidations: { checkAccountDuplicateName: true },
        },

        colWidth: 'col-md-3 col-sm-3',
      },

      {
        fieldName: 'companyType',
        labelName: 'Company Type',
        fieldType: 'dropdown',
        optionLevel: 1,
        options: CompanyType,
        value: '',
        validations: {
          staticValidations: { required: true },
        },
        colWidth: 'col-md-3 col-sm-3',
      },
      {
        fieldName: 'noOfTrucks',
        labelName: 'No of Trucks',
        fieldType: 'number',
        value: 0,
        validations: {
          staticValidations: { min: 0 },
        },
        colWidth: 'col-md-3 col-sm-3',
      },
      {
        fieldName: 'firstName',
        labelName: 'First Name',
        fieldType: 'text',
        value: '',
        validations: {
          staticValidations: { required: true },
        },
        colWidth: 'col-md-4 col-sm-4',
      },
      {
        fieldName: 'lastName',
        labelName: 'Last Name',
        fieldType: 'text',
        value: '',
        validations: {
          staticValidations: { required: true },
        },
        colWidth: 'col-md-4 col-sm-4',
      },
      {
        fieldName: 'jobTitle',
        labelName: 'Job Title',
        fieldType: 'dropdown',
        optionLevel: 1,
        options: JobTitle,
        value: '',
        validations: { staticValidations: { required: true } },
        colWidth: 'col-md-4 col-sm-4',
      },
      {
        fieldName: 'address1',
        labelName: 'Address 1',
        fieldType: 'text',
        value: '',
        validations: { staticValidations: { required: true } },
        colWidth: 'col-md-6 col-sm-6',
      },
      {
        fieldName: 'address2',
        labelName: 'Address 2',
        fieldType: 'text',
        value: '',
        validations: {},
        colWidth: 'col-md-6 col-sm-6',
      },
      {
        fieldName: 'city',
        labelName: 'City',
        fieldType: 'text',
        value: '',
        validations: { staticValidations: { required: true } },
        colWidth: 'col-md-4 col-sm-4',
      },
      {
        fieldName: 'stateProvince',
        labelName: 'State/Province',
        fieldType: 'dropdown',
        options: this.stateOptions,
        optionLevel: 2,
        value: '',
        validations: { staticValidations: { required: true } },
        colWidth: 'col-md-2 col-sm-2',
      },
      {
        fieldName: 'zipCode',
        labelName: 'Zip Code',
        fieldType: 'text',
        value: '',
        validations: { staticValidations: { required: true } },
        colWidth: 'col-md-2 col-sm-2',
      },
      {
        fieldName: 'country',
        labelName: 'Country',
        fieldType: 'dropdown',
        options: this.countryOptions,
        optionLevel: 1,
        value: '',
        validations: { staticValidations: { required: true } },
        colWidth: 'col-md-4 col-sm-4',
      },
      {
        fieldName: 'phone',
        labelName: 'Phone',
        fieldType: 'text',
        value: '',
        validations: {
          staticValidations: { required: true, phoneNumberValidator: true },
        },
        colWidth: 'col-md-4 col-sm-4',
      },
    ];
  }

  enableContinueButton(isValid: boolean) {
    this.isFormValid = isValid;
  }

  completeAccountInformation() {
    this.completeForm.emit(this.isFormValid);
  }
}
